import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { InventoryListPage } from './InventoryListPage'
import { PurchasePage } from './PurchasePage'
import { AdjustmentPage } from './AdjustmentPage'

export const InventoryPage: React.FC = () => {
  return (
    <Routes>
      <Route index element={<InventoryListPage />} />
      <Route path="purchase" element={<PurchasePage />} />
      <Route path="adjustment" element={<AdjustmentPage />} />
      <Route path="adjust/:id" element={<AdjustmentPage />} />
    </Routes>
  )
}